import {
    Button,
    Drawer,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    FormControlLabel,
    Radio,
    RadioGroup
} from "@mui/material";
import React, {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {CSVLink} from "react-csv";
import moment from "moment";
import * as FunctionsValidation from "../../../Functions/FunctionsValidation";
import StaffNZCARShowTableRow from "./StaffNZCARShowTableRow";

export default function StaffNZCAR() {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dataSuccess, setDataSuccess] = useState([]);
    const [dataError, setDataError] = useState([]);
    const [dataNew, setDataNew] = useState([]);
    const [dataNewExisting, setDataExisting] = useState([]);
    const [dataSummary, setDataSummary] = useState([{view: '', cnt: 0}]);
    const [dataFiltered, setDataFiltered] = useState([]);
    const [view, setView] = useState('new');

    const [configColoursPrimary, setConfigColoursPrimary] = useState([]);
    const [configColoursSecondary, setConfigColoursSecondary] = useState([]);
    const [configSpecies, setConfigSpecies] = useState([]);

    const [newItem, setNewItem] = useState(0);
    const [error, setError] = useState(0);
    const [success, setSuccess] = useState(0);
    const [existing, setExisting] = useState(0);

    useEffect(() => {

        loadSummary();
        FunctionsData.fetchDataGetNoLoading(FunctionsData.getApiUrl('/api/config/colours'), setConfigColoursPrimary);
        FunctionsData.fetchDataGetNoLoading(FunctionsData.getApiUrl('/api/config/colours'), setConfigColoursSecondary);
        FunctionsData.fetchDataGetNoLoading(FunctionsData.getApiUrl('/api/config/species-community'), setConfigSpecies);
        loadNew();

    }, [])

    useEffect(() => {
        console.log(setConfigSpecies, configColoursPrimary, configColoursSecondary)
    }, [setConfigSpecies, configColoursPrimary, configColoursSecondary]);


    useEffect(() => {

        try {
            setNewItem(dataSummary.find(({view}) => view === 'new').cnt ?? 0);
            setError(dataSummary.find(({view}) => view === 'error').cnt ?? 0);
            setSuccess(dataSummary.find(({view}) => view === 'success').cnt ?? 0);
            setExisting(dataSummary.find(({view}) => view === 'existing').cnt ?? 0);
        } catch (e) {
            //
        }

    }, [dataSummary]);

    useEffect(() => {
        setData([...[]]);
        setLoading(true);
    }, [view])

    useEffect(() => {

        if (loading === true) {
            loadSummary();
            if (view === 'new') loadNew();
            if (view === 'error') loadError();
            if (view === 'existing') loadExisting();
            // if(view === 'success') loadSuccess();
        }

    }, [loading]);

    useEffect(() => {

        if (view === 'new') setData([...dataNew]);
        if (view === 'error') setData([...dataError]);
        if (view === 'existing') setData([...dataNewExisting]);
        // if(view === 'success')  setData([...dataSuccess]);

    }, [dataSuccess, dataError, dataNew, dataNewExisting]);

    useEffect(() => {

        if (view === 'new') {

            let d = data;
            for (let x in d) {
                d[x]['payload'] = getPayload(d[x]);
            }
            setLoading(false);
            setDataFiltered(d);
        } else {
            setLoading(false);
            setDataFiltered(data);
        }

    }, [data,]);

    function loadNew() {
        FunctionsData.fetchDataGetNoLoading(
            FunctionsData.getApiUrl('/api/integration/nzcar/new'),
            setDataNew
        )
    }

    function loadSummary() {
        FunctionsData.fetchDataGetNoLoading(
            FunctionsData.getApiUrl('/api/integration/nzcar/summary'),
            setDataSummary
        )
    }

    function loadSuccess() {
        // console.log(view)
        // FunctionsData.fetchDataGetNoLoading(
        // 	'/api/integration/nzcar/success',
        // 	setDataSuccess,
        // )
    }

    function loadError() {
        FunctionsData.fetchDataGetNoLoading(
            FunctionsData.getApiUrl('/api/integration/nzcar/error'),
            setDataError
        )
    }

    function loadExisting() {
        FunctionsData.fetchDataGetNoLoading(
            FunctionsData.getApiUrl('/api/integration/nzcar/existing'),
            setDataExisting
        )
    }

    function getPayload(row) {

        try {

            const implanterClinic = 1079;
            const colPrimaryId = configColoursPrimary[String(row.animal_type)].filter(({label}) => label === String(row.animal_primary_colour));
            const colSecondaryId = configColoursSecondary[String(row.animal_type)].filter(({label}) => label === String(row.animal_secondary_color));
            const colSpeciesId = configSpecies.filter(({label}) => label === String(row.animal_type));


            return {
                "orders_voucher_sn": String(row.sn),
                "vet_id": String(row.vet_id),
                "microchipNumber": String(row.animal_microchip),
                "vetClinic": String(row.vet_business_name),
                "dateImplanted": moment(row.animal_date_surgery).format('YYYY-MM-DD'),
                "species": (colSpeciesId.length > 0) ? colSpeciesId[0].nzcarId : 0,
                "primaryColour": (colPrimaryId.length > 0) ? colPrimaryId[0].nzcarId : 0,
                "secondaryColour": (colSecondaryId.length > 0) ? colSecondaryId[0].nzcarId : 0,
                "name": String(row.animal_name),
                "implanterClinic": implanterClinic,
                "gender": (String(row.animal_gender) === 'undefined') ? 'Unknown' : String(row.animal_gender),
                "desexed": (row.a_type_surgery !== 'Microchip only') ? "Yes" : "No",
                "guardianFirstName": row.owner_first_name,
                "guardianSurname": row.owner_last_name,
                "guardianStreetNumber": (String(row.owner_address_number) === 'null') ? "" : String(row.owner_address_number),
                "guardianStreet": row.owner_address_street,
                "guardianSuburb": row.owner_address_suburb,
                "guardianPostalcode": String("0000" + String(row.owner_address_postcode)).slice(-4),
                "guardianCity": row.owner_address_city,
                "guardianEmail": row.owner_email,
                "guardianMobileNumber": row.owner_phone,
                "guardianAlternateNumber": ""
            }

        } catch (e) {
            console.log(e)
            return {};
        }
    }

    return (
        <div>
            <h1 style={{marginBottom: 30, marginTop: 20}}>NZCAR extract</h1>

            <div className={"stepper-box"} style={{margin: '20px 0'}}>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                >
                    <FormControlLabel value="new" onChange={(e) => setView('new')}
                                      control={<Radio checked={(view === 'new')}/>}
                                      label={<>Pending microchips ({newItem})</>}/>
                    <FormControlLabel value="error" onChange={(e) => setView('error')}
                                      control={<Radio checked={(view === 'error')}/>} label={<>Errors ({error})</>}/>
                    <FormControlLabel value="success" disabled onChange={(e) => setView('success')}
                                      control={<Radio checked={(view === 'success')}/>}
                                      label={<>Successful uploads ({success})</>}/>
                    {/* <FormControlLabel value="existing" onChange={(e) => setView('existing')}
                                      control={<Radio checked={(view === 'existing')}/>}
                                      label={<>Existing microchips ({existing})</>}/> */}
                </RadioGroup>
                <CSVLink data={data} style={{textDecoration: 'none'}}>
                    Download as CSV
                </CSVLink>
            </div>

            <TableContainer>
                <Table sx={{minWidth: 650}}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Microchip</TableCell>
                            <TableCell align="left">Type</TableCell>
                            <TableCell align="left">Animal type</TableCell>
                            <TableCell align="left">Owner</TableCell>
                            <TableCell align="left">Vet</TableCell>
                            <TableCell align="left">Procedure date</TableCell>
                            <TableCell align="left">{"JSON"}</TableCell>
                            <TableCell align="left">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataFiltered.map((row, idx) => {
                            if (loading === true) return null;
                            return (
                                <StaffNZCARShowTableRow key={idx} row={row} idx={idx} view={view} loadNew={loadNew}
                                                        loadSummary={loadSummary}
                                                        loadSuccess={loadSuccess}
                                                        loadError={loadError}
                                                        setLoading={setLoading}
                                />
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

        </div>
    )
}
